import { ProductWarehouseStatus } from 'features/inventory/products/constants';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { contractsApi } from '../../api/contracts.api';
import { mapEquipmentOptions } from '../../mappers/contracts.mappers';

export const useContractEditBootstrap = () => {
  const { t } = useTranslation();
  const [equipments, setEquipments] = useState<any[]>([]);
  const [products, setProducts] = useState<any[]>([]);
  const [categories, setCategories] = useState<any[]>([]);
  const [warehouses, setWarehouses] = useState<any[]>([]);
  const [suppliers, setSuppliers] = useState<any[]>([]);
  const [laboratories, setLaboratories] = useState<any[]>([]);
  const [statusOptions, setStatusOptions] = useState<any[]>([]);
  const [labelOptions, setLabelOptions] = useState<any[]>([]);

  const validStatuses = Object.keys(ProductWarehouseStatus);

  useEffect(() => {
    let mounted = true;
    Promise.all([
      contractsApi.getCategoryOptions(),
      contractsApi.getEquipmentBase(),
      contractsApi.getProductBase(),
      contractsApi.getWarehouseBase(),
      contractsApi.getSupplierBase(),
      contractsApi.getLaboratoryBase(),
      contractsApi.getProductWarehouseOptions(),
      contractsApi.getLabelThresholds()
    ]).then(
      ([
        categoryData,
        equipmentData,
        productData,
        warehouseData,
        supplierData,
        laboratoryData,
        productWarehouseOptions,
        thresholds
      ]) => {
        if (!mounted) return;
        setCategories(categoryData || []);
        setEquipments(mapEquipmentOptions(equipmentData || []));
        setProducts(productData || []);
        setWarehouses(warehouseData || []);
        setSuppliers(
          (supplierData || []).map((s) => ({ id: s.id, code: `${s.code} - ${s.company_name}` }))
        );
        setLaboratories(laboratoryData || []);
        setStatusOptions(
          (productWarehouseOptions?.actions?.POST?.status?.choices || [])
            .filter((item) => validStatuses.includes(item.display_name))
            .map((item) => ({
              ...item,
              display_name: t(`entities.product.status_options.${item.display_name}`)
            }))
        );
        setLabelOptions(thresholds?.results || []);
      }
    );

    return () => {
      mounted = false;
    };
  }, [t]);

  return {
    equipments,
    products,
    categories,
    warehouses,
    suppliers,
    laboratories,
    statusOptions,
    labelOptions,
    setProducts,
    setWarehouses
  };
};
